import { getShipperWithProfiles as _getShipperWithProfiles } from 'domain/operations/shippers/utils';

export const getShipperWithProfiles = _getShipperWithProfiles;
